// extracted by mini-css-extract-plugin
module.exports = {"page":"__9DSr6QvR","g-main":"N_TZP3RJ","static":"mT__3a_x","isProduct":"N4yqu_6S"};